<div class="iframe-link"
  *ngIf="!!frame"
>
  <div class="iframe-link_capture"></div>
  <iframe [ngStyle]="frame.style" style="background: rgba(0, 0, 0, 0.4)"
          [src]="sanitizer.bypassSecurityTrustResourceUrl(floors[(floorService.selectedFloor | async) - 1][frame.url])"></iframe>
 </div>
